import { cloneElement, forwardRef } from "react";
import { useDrawer } from "../providers";
export const DrawerCloseTrigger = forwardRef((props, ref) => {
    const { closeDrawer } = useDrawer();
    const Component = props.children[0] || props.children;
    const mergedOnClick = (event) => {
        Component.props?.onClick?.(event);
        closeDrawer();
    };
    return cloneElement(Component, { ...Component.props, onClick: mergedOnClick, ref }, Component.props.children);
});
DrawerCloseTrigger.displayName = "DrawerCloseTrigger";
//# sourceMappingURL=DrawerCloseTrigger.js.map